<div class="modal-content modal-content-right">
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="far fa-user-circle"></i>Pause Subscription
    </h5>
    <button
      type="button"
      class="close invoice_closemodal_button"
      (click)="close()"
      aria-label="Close"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-row">
      <div class="form-group">
        <label class="form-label">Resume Date</label>
        <input
          class="form-control invoice_resumedate_input"
          type="date"
          [ngModel]="resumeDate | date: 'yyyy-MM-dd'"
          (blur)="forceMinDate($event)"
          [min]="minDate"
          (ngModelChange)="resumeDate = $event"
        />
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-outline invoice_confirm_button"
        (click)="ok()"
      >
        Ok
      </button>
    </div>
  </div>
</div>
